const BLOG_HOST = 'https://www.okcoin.jp/blog';

const BLOG_API = `${BLOG_HOST}/wp-json/wp/v2`;

const { isUnifiedAccount = false } = window.okGlobal;

const PAGE_URLS = {
  account_balance: '/account/balance',
  staking: '/earn/staking',
  recurring: '/recurring-buy',
  recurringLandingPage: '/pages/recurring',
  login: '/account/login?forward=',
  register: '/account/register',
  trade: isUnifiedAccount ? '/trade-spot' : '/spot/trade',
};

export { PAGE_URLS, BLOG_HOST, BLOG_API };
